import React, { DetailedHTMLProps, InputHTMLAttributes, ReactNode } from 'react'
import clsx from 'clsx'
import { UseFormRegisterReturn } from 'react-hook-form'

type Props = {
  name: string
  label: string
  field?: UseFormRegisterReturn<string>
  contentAtEnd?: ReactNode
  hasError?: boolean
} & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

export default function InputWithFloatingLabel({
  label,
  contentAtEnd,
  hasError,
  field,
  ...props
}: Props) {
  // Name is useful in other places like assigning label
  const { name, value, disabled } = props

  return (
    <div className="relative flex items-center">
      {contentAtEnd && (
        <div className="absolute right-0 pr-4">{contentAtEnd}</div>
      )}
      <input
        id={name}
        {...props}
        {...field}
        className={clsx(
          'peer block h-[4.5rem] w-full rounded-2xl border-0 px-4 pb-0 text-base text-gray-900 ring-2 ring-inset focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:leading-6',
          hasError ? 'ring-red-600' : 'ring-gray-300',
          disabled ? 'bg-gray-300' : '',
        )}
      />
      <label
        htmlFor={name}
        className={clsx(
          'absolute origin-top-left pl-4 text-base text-gray-400 transition-all duration-300',

          // If the field is not empty, leave the label up top
          value
            ? '-translate-y-3 translate-x-1 scale-75'
            : 'peer-focus:-translate-y-3 peer-focus:translate-x-1 peer-focus:scale-75',
        )}
      >
        {label}
      </label>
    </div>
  )
}
